/** API route map: URLS.Controller.ClientContact */
export const ClientContact = {
      Name: 'ClientContact/',
      AddClientContact: 'add-client-contact',
      updateContact: 'update',
      deleteContact: 'delete',
      GetAll: 'client-contacts',
      Tiles: 'tiles',
      GetClientContactSummary: 'get-client-contact-summary',
      UpdateClientContact: 'patch-contact',
      UpdateClientContactProfileImage: 'update-contact-profile-image',
      GetClientContactDepartment: 'get-client-contact-department',
      AddContactDescription: 'add-contact-description',
};
